import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { Typography } from "@mui/material";
import useStyles from "./style";
import jsonUtils from "../../utils/jsonUtils";

const ComponentDadosBasicos = (props) => {
  const relatorio = props.relatorio;
  const classes = useStyles();

  const documentosProcessados = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.PERCENTUAL_DOCUMENTOS_PROCESSADOS", relatorio);
  const documentoFormatado = parseFloat((documentosProcessados || "0").replace(',', '.'));

  const volume = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.PERCENTUAL_VOLUME_PROCESSADO", relatorio);
  const volumeFormatado = parseFloat((volume || "0").replace(',', '.'));

  const pontuacao = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.SCORE.PONTUACAO", relatorio);

  const documento = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.DOCUMENTO", relatorio);

  const data = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.DATA_INICIO_RELACIONAMENTO", relatorio);

  const instituicoes = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.QUANTIDADE_INSTITUICOES", relatorio);

  return (
    <div className={classes.component}>
      <div className={classes.aligncomponents}>
        <div className={classes.aligndivs}>
          <div className={classes.align}>
            <Typography
              variant="h6"
              fontSize="18px"
              fontWeight="700"
              className={classes.doc}>
              Documento
            </Typography>

            <div className={classes.componentDoc}>
              <p className={classes.para}>{ documento || "000.000.000-00" }</p>
            </div>
          </div>
          <div className={classes.alignpont}>
            <Typography
              variant="h6"
              fontSize="18px"
              fontWeight="700"
              className={classes.doc}>
              Pontuação
            </Typography>

            <ProgressBar width="256px" height="30px" completed={ pontuacao || "0" } maxCompleted="1000" borderRadius="46.06px" bgColor="linear-gradient(90deg, #D65C56 0%, #F8BD08 50%, #2ED227 100%)" />
          </div>

        </div>

        <div className={classes.aligndivs}>
          {/* <div className={classes.align}>
            <Typography
              variant="h6"
              fontSize="18px"
              fontWeight="700"
              className={classes.doc}>
              Nome / Razão Social
            </Typography>

            <div className={classes.componentData}>
              <p className={classes.para}>Cliente x</p>
            </div>
          </div> */}

          <div className={classes.aligndata}>
            <Typography
              variant="h6"
              fontSize="18px"
              fontWeight="700"
              className={classes.doc}>
              Data de início do relacionamento
            </Typography>

            <div className={classes.componentData}>
              <p className={classes.para}>{ data || "NÃO INICIADO" }</p>
            </div>
          </div>

        </div>
      </div>

      <div className={classes.aligncomponentstwo}>
        <div className={classes.alignporc}>
          <Typography
            variant="h6"
            fontSize="18px"
            fontWeight="700"
            className={classes.doc}>
            Percentual de documentos processados
          </Typography>

          <ProgressBar width="256px" height="30px" margin="2px 9px" completed={ documentoFormatado || "0" } maxCompleted={100} borderRadius="46.06px" bgColor="linear-gradient(90deg, #D65C56 0%, #F8BD08 50%, #2ED227 100%)" />
        </div>

        <div className={classes.alignporctwo}>
          <Typography
            variant="h6"
            fontSize="18px"
            fontWeight="700"
            className={classes.doc}>
            Percentual do volume processado
          </Typography>

          <ProgressBar width="256px" height="30px" margin="2px 55px" completed={ volumeFormatado || "0" } maxCompleted={100} borderRadius="46.06px" bgColor="linear-gradient(90deg, #D65C56 0%, #F8BD08 50%, #2ED227 100%)" />
        </div>

        <div className={classes.alignquant}>
          <Typography
            variant="h6"
            fontSize="18px"
            fontWeight="700"
            className={classes.doc}>
            Quantidade de instituições
          </Typography>

          <div className={classes.componentquant}>
            <p className={classes.para}>{ instituicoes || "0" }</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ComponentDadosBasicos;
